
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tou",
      function () {
        return require("private-next-pages/tou/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tou"])
      });
    }
  